import React, { useState, useEffect } from 'react';
import { Loader, Border700, Bg100, Text700, Bg300 } from '../components/common'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TrashIcon, CheckIcon, UserIcon } from '@heroicons/react/24/outline'
import { Welcoming } from '../components/SVGs';

export default function News({ token, profileData }) {
    const [announcements, setAnnouncements] = useState([]);
    const [newAnnouncement, setNewAnnouncement] = useState({
        title: '',
        status: 'gray',
        content: '',
    });

    /**
     * Announcement statuses; make sure they make part of TailwindCSS colors classes
     */
    const statuses = [
        'gray',
        'blue',
        'green',
        'orange',
        'red',
    ];

    const endpoint = `${process.env.REACT_APP_API_URL}/announcements`;
    const [isLoading, setIsLoading] = useState(false);

    // Fetch announcements
    useEffect(() => {
        fetchAnnouncements()
        // toast.info('Rendered')
    }, []);


    /**
     * @returns void
     */
    const fetchAnnouncements = () => {
        setIsLoading(true)
        fetch(`${endpoint}`, {
            headers: {
                'access-key': token,
                'Content-Type': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                if (data.hasOwnProperty('announcements'))
                    setAnnouncements(data.announcements);
            })
            .catch(error => {
                setIsLoading(false);
                toast.error('Failed retrieving announcements!');
            });

    }


    const [isSavingAnnouncement, setIsSavingAnnouncement] = useState(false);
    // Add announcement
    const addAnnouncement = () => {
        if (newAnnouncement.title && newAnnouncement.content && newAnnouncement.status) {
            setIsSavingAnnouncement(true)
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'access-key': token,
                },
                body: JSON.stringify(newAnnouncement)
            })
                .then(response => response.json())
                .then(data => {
                    const announcementsData = announcements;
                    announcementsData.unshift(data.announcement);
                    setAnnouncements(announcementsData);
                    setIsSavingAnnouncement(false)
                    setNewAnnouncement({
                        title: '',
                        status: 'gray',
                        content: '',
                    });
                    toast.success('Announcement has been saved successfully.')
                    setShowAnnouncementModal(false);
                })
                .catch(error => {
                    setIsSavingAnnouncement(false)
                    toast.error('Failed.')
                });
        }
        else {
            toast.warning('Nothing to save!');
        }
    };

    // Delete announcement
    const deleteAnnouncement = (announcementId) => {
        setIsLoading(true)
        fetch(endpoint + '?announcement_id=' + announcementId, {
            method: 'DELETE',
            headers: {
                'access-key': token,
            }
        })
            .then(() => {
                const updatedAnnouncements = announcements.filter(announcement => announcement.id !== announcementId);
                setAnnouncements(updatedAnnouncements);
                toast.success('Anouncement has been deleted successfully');
                setIsLoading(false)
            })
            .catch(error => {
                toast.success('Cannot delete announcement!');
                setIsLoading(false)
            });
    };


    /**
     * Add announcement Modal
     */
    const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
    const handleModalSubmit = (e) => {
        e.preventDefault();
        addAnnouncement();
    }

    const formatDate = (date) => {
        const d = new Date(date)
        return d.toLocaleDateString('en-US', {
            day: 'numeric',
            weekday: 'short',
            month: 'short',
            hour: 'numeric',
            minute: 'numeric',
        })
    }

    const getStatusCssClasses = (status) => {
        switch (status) {
            case 'blue':
                return `h-12 w-12 rounded-full bg-blue-300 border-2 border-gray-300 m-3 hover:border-gray-500 transition-all relative`
            case 'green':
                return `h-12 w-12 rounded-full bg-green-300 border-2 border-gray-300 m-3 hover:border-gray-500 transition-all relative`
            case 'orange':
                return `h-12 w-12 rounded-full bg-orange-300 border-2 border-gray-300 m-3 hover:border-gray-500 transition-all relative`
            case 'red':
                return `h-12 w-12 rounded-full bg-red-300 border-2 border-gray-300 m-3 hover:border-gray-500 transition-all relative`
            default:
                return `h-12 w-12 rounded-full bg-gray-300 border-2 border-gray-300 m-3 hover:border-gray-500 transition-all relative`;
        }
    }

    return (
        <div className="m-auto md:w-2/3 lg:w-2/3 xl:w-2/3 justify-center items-center relative mb-4 pb-4">
            <h2 className="text-primary-700 text-2xl font-bold mb-4 w-full">Announcements</h2>
            {
                // RESERVED FOR ADMIN
                profileData.role.name === 'admin'
                    ?
                    <button onClick={() => setShowAnnouncementModal(true)}
                        className='transition-all items-center flex text-primary-500 absolute top-0 right-0 p-2 border
                border-primary-100 cursor-pointer hover:border-primary-300 rounded-full hover:bg-white text-xl'
                    >
                        <svg className='w-6 h-6 inline-block mr-2 text-primary-500 fill-primary-500' x="0px" y="0px" viewBox="0 0 123.52 113.54">
                            <g><path className="st0" d="M82.33,16.91c-1.07,0.88-2.65,0.74-3.54-0.34s-0.74-2.65,0.34-3.54L94.2,0.58c1.07-0.88,2.65-0.74,3.54,0.33 c0.88,1.07,0.74,2.65-0.34,3.54L82.33,16.91L82.33,16.91L82.33,16.91z M9.12,60.78c-1.66,0.49-2.88,1.57-3.69,3 c-0.93,1.65-1.35,3.78-1.32,6.06c0.01,0.98,0.11,1.99,0.28,3.01c0.17,1.03,0.43,2.06,0.75,3.07c0.33,1.02,0.73,2.01,1.2,2.96 c0.46,0.92,0.98,1.8,1.55,2.6l0,0c1.4,1.95,3.14,3.5,5.15,4.28c1.75,0.69,3.72,0.79,5.84,0.06l0.04-0.01 c0.24-0.08,0.48-0.11,0.72-0.09c0.17,0.01,0.34,0.04,0.51,0.09l0.05-0.02c0.57-0.19,1.16-0.37,1.74-0.55l1.59-0.49 c0.58-0.17,1.13-0.33,1.65-0.48c0.51-0.15,1.03-0.29,1.56-0.43c0.55-0.15,1.1-0.06,1.56,0.2l0.05,0.03 c0.43,0.26,0.76,0.68,0.91,1.21c0.03,0.09,0.04,0.16,0.05,0.24c0.14,0.63,0.31,1.28,0.43,1.91c1.09,4.88,2.15,9.58,3.56,13.39 c0.12,0.38,0.27,0.75,0.41,1.13c0.43,1.2,0.88,2.44,1.38,3.57c0.48,1.1,0.99,2.08,1.57,2.8l0,0.01c0.43,0.54,0.93,0.88,1.52,0.91 c0.65,0.03,1.46-0.28,2.48-1.07c0.44-0.41,0.84-0.76,1.25-1.11l0.09-0.08c1.2-1.04,2.4-2.07,2.92-3.48 c-0.08-0.06-0.17-0.12-0.27-0.17c-0.23-0.13-0.52-0.26-0.81-0.38l-0.03-0.01c-1.07-0.45-2.13-0.91-2.9-1.87 c-0.78-0.97-1.2-2.38-0.91-4.68c0.01-0.14,0.03-0.26,0.05-0.38c0.02-0.14,0.04-0.28,0.05-0.42c0.13-1.04,0.2-1.58,0.16-1.73l0-0.02 c-0.03-0.04-0.24-0.19-0.66-0.58c-0.12-0.11-0.25-0.22-0.36-0.34c-0.62-0.58-1.06-1.27-1.34-2.03c-0.31-0.84-0.43-1.76-0.42-2.72 c0.01-0.94,0.15-1.92,0.36-2.85c0.26-1.13,0.63-2.21,1-3.1l0.02-0.03c0.14-0.33,0.36-0.6,0.62-0.8c0.28-0.22,0.62-0.36,0.97-0.41 l0.02,0c7.57-1.05,13.68-0.91,18.81-0.25c4.63,0.6,8.44,1.61,11.83,2.57c-2.59-2.95-4.97-6.42-7.12-10.2 c-2.77-4.88-5.15-10.29-7.07-15.77c-1.94-5.54-3.41-11.16-4.33-16.4c-0.77-4.4-1.16-8.54-1.11-12.13 c-2.89,4.15-6.78,9.19-12.5,14.27c-6.53,5.79-15.45,11.63-28.01,16.25c-0.13,0.04-0.26,0.09-0.39,0.13l-0.06,0.1 c0,0,0.01-0.01-0.22,0.35l-0.02,0.03c-0.13,0.2-0.29,0.37-0.47,0.51l0,0c-0.2,0.15-0.42,0.27-0.66,0.34L9.12,60.78L9.12,60.78z M66.17,68.52c1.88,3.61,3.96,6.97,6.21,9.88c2.14,2.76,4.44,5.13,6.86,6.92l0.25,0.02c0.12,0.01,0.24,0.01,0.34,0l0.04,0 c0.19-0.01,0.38-0.04,0.58-0.1c0.19-0.06,0.39-0.15,0.6-0.27c0.51-0.52,0.93-1.2,1.27-2c0.38-0.88,0.66-1.92,0.84-3.08 c0.55-3.43,0.29-7.82-0.56-12.67c-0.93-5.3-2.58-11.13-4.66-16.84c-2.04-5.61-4.5-11.09-7.12-15.83 c-2.49-4.52-5.12-8.36-7.66-10.99c-0.95-0.99-1.87-1.78-2.74-2.35c-0.81-0.53-1.56-0.87-2.25-0.98l-0.02,0 c-0.16-0.03-0.29-0.04-0.39-0.05c-0.04,0,0-0.03-0.02-0.02l0,0c-0.01,0-0.01,0.02-0.06,0.06c-0.09,0.08-0.22,0.2-0.37,0.35 c-0.13,0.12-0.26,0.27-0.38,0.41l-0.04,0.08c-1.16,2.4-1.56,6.2-1.31,10.83c0.26,4.7,1.2,10.23,2.73,15.97 c4.35-1,7.75-0.08,10.09,1.87c1.37,1.14,2.36,2.62,2.97,4.27c0.6,1.64,0.82,3.45,0.64,5.26C71.67,62.82,69.76,66.34,66.17,68.52 L66.17,68.52z M78.89,89.41c-0.2,0.03-0.4,0.03-0.6,0c-0.19-0.03-0.38-0.08-0.56-0.17c-0.27-0.05-0.54-0.1-0.8-0.16 c-1.89-0.39-3.73-0.92-5.71-1.48l-0.13-0.04c-6.79-1.93-15.28-4.35-28.88-2.67c-0.18,0.52-0.33,1.08-0.45,1.63 c-0.12,0.58-0.19,1.16-0.2,1.69c0,0.42,0.04,0.81,0.13,1.13c0.07,0.24,0.18,0.44,0.33,0.58l0.24,0.22 c1.11,1.01,1.65,1.51,1.96,2.65c0.25,0.92,0.14,1.77-0.08,3.45c-0.03,0.23-0.05,0.46-0.09,0.69c-0.1,0.81,0.03,1.28,0.27,1.57 c0.25,0.3,0.68,0.49,1.12,0.67l0.05,0.02c1.4,0.6,2.8,1.21,3.52,3.2c0.08,0.18,0.13,0.38,0.15,0.58c0.02,0.2,0.02,0.4-0.02,0.61 l0,0.01c-0.31,1.61-0.97,2.84-1.8,3.89c-0.81,1.03-1.77,1.85-2.72,2.67l-0.22,0.19c-0.33,0.28-0.65,0.56-0.96,0.86l-0.16,0.14 c-2.17,1.73-4.02,2.35-5.65,2.18c-1.65-0.17-3.02-1.15-4.18-2.61c-0.8-1-1.46-2.23-2.05-3.54c-0.58-1.3-1.08-2.67-1.56-4 c-0.13-0.37-0.27-0.74-0.41-1.11c-1.48-3.99-2.57-8.84-3.69-13.85c-0.36,0.1-0.72,0.22-1.08,0.32c-0.56,0.17-1.11,0.33-1.64,0.5 c-0.54,0.17-1.07,0.34-1.59,0.5l-0.03,0.01c-0.08,0.02-0.14,0.05-0.19,0.07l-0.03,0.01c-0.38,0.16-0.66,0.27-0.98,0.3 c-0.29,0.03-0.56,0-0.88-0.12c-2.89,0.8-5.56,0.56-7.94-0.4c-2.7-1.1-5.02-3.15-6.86-5.72L4.5,83.86 c-0.69-0.99-1.31-2.05-1.86-3.17c-0.56-1.13-1.03-2.31-1.42-3.51c-0.39-1.2-0.69-2.43-0.89-3.66C0.13,72.3,0.02,71.08,0,69.88 c-0.03-3.02,0.56-5.88,1.87-8.19C3.05,59.62,4.81,58,7.2,57.1c0.09-0.14,0.16-0.26,0.24-0.36c0.13-0.17,0.27-0.32,0.46-0.48 l0.04-0.03c0.2-0.17,0.39-0.28,0.61-0.39c0.2-0.09,0.43-0.18,0.74-0.29l0.28-0.1c12.71-4.68,21.5-10.66,27.81-16.51 c6.31-5.85,10.15-11.57,12.92-15.73l0.06-0.09c1.55-2.32,2.8-4.17,4.05-5.42l0,0c0.32-0.32,0.6-0.58,0.9-0.8 c0.31-0.23,0.63-0.41,1-0.55c0.39-0.14,0.77-0.22,1.18-0.24c0.4-0.02,0.83,0.02,1.33,0.1c1.18,0.19,2.38,0.68,3.59,1.44 c1.23,0.77,2.47,1.82,3.7,3.1c2.74,2.84,5.56,6.94,8.21,11.73c2.76,4.98,5.34,10.7,7.46,16.55c2.18,6,3.9,12.14,4.87,17.77 c0.89,5.19,1.15,9.96,0.53,13.77c-0.26,1.6-0.67,3.06-1.24,4.32c-0.56,1.24-1.29,2.31-2.19,3.18c-0.04,0.04-0.09,0.08-0.13,0.12 c-0.06,0.04-0.12,0.09-0.18,0.13c-0.59,0.39-1.16,0.67-1.73,0.85c-0.58,0.19-1.16,0.28-1.74,0.31h-0.04c-0.2,0-0.39,0-0.57-0.01 C79.22,89.44,79.05,89.43,78.89,89.41L78.89,89.41z M103.5,78.48c-1.39,0.06-2.55-1.02-2.6-2.41c-0.06-1.39,1.02-2.55,2.41-2.6 l17.6-0.66c1.38-0.04,2.54,1.04,2.6,2.41c0.05,1.39-1.02,2.55-2.41,2.61L103.5,78.48L103.5,78.48L103.5,78.48z M103,61.38 c-1.38,0.18-2.64-0.79-2.82-2.15c-0.18-1.38,0.79-2.64,2.15-2.82l16.26-2.16c1.38-0.18,2.64,0.79,2.82,2.15 c0.18,1.38-0.79,2.64-2.15,2.82L103,61.38L103,61.38L103,61.38z M99.58,45.68c-1.31,0.45-2.75-0.24-3.2-1.55 c-0.46-1.31,0.24-2.75,1.55-3.2l16.67-5.79c1.31-0.47,2.75,0.24,3.2,1.55c0.46,1.31-0.24,2.75-1.55,3.2L99.58,45.68L99.58,45.68 L99.58,45.68z M91.72,30.57c-1.2,0.69-2.74,0.27-3.42-0.94c-0.69-1.2-0.27-2.73,0.94-3.42l15.8-9.06c1.2-0.69,2.74-0.27,3.42,0.94 c0.69,1.2,0.27,2.73-0.94,3.42L91.72,30.57L91.72,30.57L91.72,30.57z" /></g></svg>
                        <p>New</p>
                    </button>
                    : <></>
            }

            {/* Announcements list */}
            <div className='mx-8 my-6'>
                <ul>
                    {announcements.map(announcement => (
                        <li key={announcement.id} className={`my-4 py-4 px-3 rounded-xl relative border-l-4  ${Border700(announcement.status)} ${Bg100(announcement.status)} ${Text700(announcement.status)}`}>
                            <div className=''>
                                <div className='flex mb-2'>
                                    {/* Author */}
                                    <div className='flex'>
                                        {
                                            announcement.author && announcement.author.photo
                                                ? <img className={`h-10 w-10 rounded-full border ${Border700(announcement.status)}`} src={`${process.env.REACT_APP_API_URL}/${announcement.author.photo}`} />
                                                : <UserIcon className={`h-10 w-10 rounded-full border ${Border700(announcement.status)}`} />
                                        }
                                    </div>
                                    {/* Title */}
                                    <p className='p-1 ml-2'>{announcement.author && announcement.author.name ? announcement.author.name : 'Admin'}</p>
                                    {/* Date */}
                                    <p className='p-1 ml-2'>{announcement.created_at ? formatDate(announcement.created_at) : ''}</p>
                                </div>
                                <p className={`underline text-lg font-bold ${Text700(announcement.status)}`} >{announcement.title}</p>
                                <pre className='text-base font-serif'>{announcement.content}</pre>
                            </div>
                            {
                                // RESERVED FOR ADMIN
                                profileData.role.name === 'admin'
                                    ? <button onClick={() => deleteAnnouncement(announcement.id)}
                                        className="absolute top-0 right-0 p-1">
                                        <TrashIcon className='p-1 h-8 w-8 border border-red-100 bg-gray-100 text-red-500 hover:border-red-300 hover:bg-white hover:text-red-700 transition-all rounded-full ' />
                                    </button>
                                    : <></>
                            }
                        </li>
                    ))}
                </ul>


                {
                    announcements.length < 1 ?
                        <div className='py-4'>
                            <Welcoming />
                        </div>
                        : <></>
                }
            </div>




            {/* RESERVED FOR ADMIN New announcements */}
            {
                showAnnouncementModal && (
                    <div className="w-auto">
                        <div className='fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-10'>
                            <form onSubmit={handleModalSubmit} className="bg-gray-100 shadow-md rounded-lg mb-4 md:w-1/3 lg:w-1/3">
                                {/* Title */}
                                <h2 className={`transition-all items-center shadow text-2xl text-left p-4 rounded-lg ${Bg300(newAnnouncement.status)}`}>
                                    <p className='transition-all text-primary-700 '>What's the news {profileData.name} ?</p>
                                </h2>
                                <div className='m-auto px-8'>
                                    {/* Statuses */}
                                    <div className='flex py-4 bg-gray-100 m-auto justify-center mb-4'>
                                        {
                                            statuses.map(status => {
                                                return (<p className={getStatusCssClasses(status)}
                                                    onClick={() => setNewAnnouncement((prev) => { return { ...prev, status } })}>
                                                    {(newAnnouncement.status === status && <CheckIcon className='h-8 w-8 text-primary-500 absolute -top-1 -right-2' />)}
                                                </p>)

                                            })
                                        }
                                    </div>

                                    {/* Title */}
                                    <div className='mb-4'>
                                        <input
                                            placeholder='Title'
                                            required={true}
                                            type="text"
                                            value={newAnnouncement.title}
                                            onChange={(e) => setNewAnnouncement((prev) => { return { ...prev, title: e.target.value } })}
                                            className="w-3/4 py-2  outline-0 border-b border-gray-200 focus:border-primary-200 text-primary-500 text-base"
                                        />
                                    </div>

                                    {/* Content */}
                                    <div className='mb-4'>
                                        <textarea
                                            placeholder='Type something here..'
                                            required={true}
                                            type="text"
                                            value={newAnnouncement.content}
                                            onChange={(e) => setNewAnnouncement((prev) => { return { ...prev, content: e.target.value } })}
                                            className="w-full py-2 h-32 outline-0 border-b border-gray-200 focus:border-primary-200 text-primary-500 text-base"
                                        />
                                    </div>
                                </div>

                                {/* Footer / Action buttons */}
                                <div className="flex items-center justify-end mt-4 p-2">
                                    <button
                                        type="button"
                                        className="bg-gray-500 text-white px-4 py-2 rounded-full transition-all border border-white ring-gray-500 hover:bg-gray-500 hover:ring-2"
                                        onClick={() => setShowAnnouncementModal(false)}
                                    >
                                        {'Close'}
                                    </button>

                                    <button
                                        type="submit"
                                        className="ml-4 bg-primary-500 text-white px-4 py-2 rounded-full transition-all border border-white ring-primary-500 hover:bg-primary-500 hover:ring-2"
                                        disabled={isSavingAnnouncement} // Disable the button when isSavingAnnouncement is true
                                    >
                                        {isSavingAnnouncement ? '...' : 'Save'}
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>

                )
            }
            <ToastContainer />


            {(isLoading) && <Loader height={'auto'} width={'fit-content'} />}
        </div>
    );
}
